import { render, staticRenderFns } from "./AdminNotice.vue?vue&type=template&id=89d3504e&scoped=true&"
import script from "./AdminNotice.vue?vue&type=script&lang=js&"
export * from "./AdminNotice.vue?vue&type=script&lang=js&"
import style0 from "./AdminNotice.vue?vue&type=style&index=0&id=89d3504e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d3504e",
  null
  
)

export default component.exports